/** Daily credit costs — keep in sync with backend {@code AiOperation}. */
export const AI_CREDIT_COSTS = {
  practiceGenerate: 3,
  comprehensionGenerate: 3,
  comprehensionCheck: 1,
  articleGenerate: 5,
} as const

/** @deprecated Prefer {@link maxPracticeUnits} from `@/config/practiceLimits`. */
export { maxPracticeUnits as PRACTICE_WORD_LIMIT } from '@/config/practiceLimits'

export type AiCreditOperation = keyof typeof AI_CREDIT_COSTS

export function formatCreditCost(cost: number): string {
  return `${cost} credit${cost === 1 ? '' : 's'}`
}

export function formatCreditDebit(cost: number): string {
  return `−${formatCreditCost(cost)}`
}
